import { create } from 'zustand'
import {
  deviceIdPromise,
  type DeviceIdPromise,
} from '@/src/common/hooks/useDeviceId/deviceIdPromise'

/** @todo replace this with [`React.use`](https://react.dev/reference/react/use) once we upgrade to expo 53 and get access to React 19  */
export const useDeviceId = create<DeviceIdPromise | Awaited<DeviceIdPromise>>(
  (set) => ((async () => set(await deviceIdPromise))(), deviceIdPromise),
)
